import React, { FC } from 'react';

import { Box } from '@chakra-ui/react';

import { Drawer } from 'components/Overlay';
import { MetadataHeader } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataHeader';
import { ResourceMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

export const NodeMetadataDrawer: FC = () => {
  const {
    onCloseMetadata,
    isOpenMetadata,
    onOpenMetadata,
    canGoBackMetadata,
    onBackMetadata,
  } = useActiveResourceContext();

  // Unmount the drawer when closed so its overlay cannot intercept clicks on
  // the drawer or graph underneath it.
  if (!isOpenMetadata) return null;

  return (
    <Drawer
      onOpen={onOpenMetadata}
      isOpen={isOpenMetadata}
      onClose={onCloseMetadata}
      header={
        <MetadataHeader
          onBack={canGoBackMetadata ? onBackMetadata : undefined}
        />
      }
      body={
        <Box h="full" w="full">
          <ResourceMetadata />
        </Box>
      }
      closeButton
      styles={{
        content: { maxW: '1500px' },
        body: { overflowY: 'auto' },
        drawer: {
          trapFocus: false,
        },
      }}
    />
  );
};
